const normalize = (value) => String(value ?? '').replace(/\s+/g, ' ').trim().toLowerCase();

/**
 * True when the patroller matches the search text. Matches (partial, case-insensitive)
 * the full name, email, phone, NSP number, or any certification name.
 */
export const matchesPatrollerSearch = (patroller, search) => {
    const query = normalize(search);

    if (!query) {
        return true;
    }

    if (!patroller) {
        return false;
    }

    const fullName = normalize(`${patroller.firstName ?? ''} ${patroller.lastName ?? ''}`);
    const certNames = (Array.isArray(patroller.certifications) ? patroller.certifications : [])
        .map(cert => normalize(cert?.name));

    return [
        fullName,
        normalize(patroller.email),
        normalize(patroller.phoneNumber),
        normalize(patroller.nspNumber),
        ...certNames
    ].some(field => field && field.includes(query));
};
